import { BaseFiltroPagDTO } from "./base-dto";

export class NotificacaoParmDTO {
  id: number;
  titulo: string;
  templateJson: string;
  larguraMaxTemplate: number;
  conteudoHtml: string;
  diaInicioPublicacao: string;
  horaInicioPublicacao: string;
  diaFimPublicacao: string;
  horaFimPublicacao: string;
  ativo: boolean = true;
  popup: boolean;
  alvo:string;
  idsPerfil: number[];
  idsEmpresa: number[];
  idsLogin: number[];
  idsUnidade: number[];
  idsTime: number[];
}

export class NotificacaoFiltroDTO extends BaseFiltroPagDTO {
  titulo: string;
  ativo: boolean;
  popup: boolean;
  lido: boolean;
  tipo: string;
  alvo: string;
  idPerfil: number;
  idLogin: number;
  idEmpresa: number;
  idUnidade: number;
  idTime: number;
  visivelNaData: string;
  situacaoAtual: string;
}

export const NOTIF_TIPO_GENERICO = 'GN';

export const NOTIF_TARGET_PROFILES = 'PERFIL';
export const NOTIF_TARGET_USERS = 'LOGIN';
export const NOTIF_TARGET_CLIENT_UNITS = 'UNIDADE';
export const NOTIF_TARGET_TEAMS = 'TIME'; 

export const NOTIF_TARGET_LIST = [
  {id: NOTIF_TARGET_PROFILES, nome: 'Perfis'}, 
  {id: NOTIF_TARGET_USERS, nome: 'Usuários'}, 
  {id: NOTIF_TARGET_CLIENT_UNITS, nome: 'Unidades'}, 
  {id: NOTIF_TARGET_TEAMS, nome: 'Times'}, 
];